export enum KeyboardKeys {
  ENTER = "Enter",
  ESCAPE = "Escape",
}
